<template>
  <div>
    <div v-if="isactive" class="popo">
      <van-index-bar v-if="isactive" :index-list="indexlist" :z-index="1000">
        <div v-for="(item,index) in lists" :key="index">
          <van-index-anchor :index="index" />
          <van-cell :title="v" @click="swap(v)" v-for="(v,i) in lists[index]" :key="i" />
        </div>
      </van-index-bar>
      <div class="popupclose">
        <van-icon name="close" size="30" @click="isactive=false" />
      </div>
    </div>

    <van-row :gutter="15">
      <van-col :span="16">
        <p v-for="i in length" :key="i" class="searchValue">
          <input
            type="text"
            class="form-input-c"
            placeholder="填写小区名称"
            v-model="searchValue[i-1]"
            @blur="blur"
          />
        </p>
      </van-col>
      <van-col :span="8">
        <div class="xiaoqu" @click="isactive=true">
          选择小区
          <van-icon name="arrow-down" />
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {
  Button,
  Icon,
  Row,
  Col,
  Tag,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Popup
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup
  },

  data() {
    return {
      isactive: false,
      data: this.lists,
      searchValue: [],
      indexlist: [],
      scroll: 0,
      length: 1
    };
  },
  props: {
    lists: {
      type: Object,
      default: {}
    }
  },

  mounted() {
    this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
       this.indexlist = Object.keys(this.lists);
  },
  watch: {
    lists: function() {
      this.indexlist = Object.keys(this.lists);

    }
  },
  methods: {
    swap(value) {
      this.isactive = false;

      document.documentElement.scrollTop = this.scroll;
      window.pageYOffset = this.scroll;
      document.body.scrollTop = this.scroll;
      this.searchValue[this.length - 1] = value;
      if (this.length < 3) {
        this.length++;
      }

      this.$emit("change", this.searchValue);
    },
    blur() {
      this.$emit("change", this.searchValue);
    }
  }
};
</script>

<style scoped>
.popo {
  position: absolute;
  z-index: 3000;
  background-color: #fff;
  top: 0;
  width: 95vw;
  z-index: 1000;
}
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.form-box-tag.active {
  background-color: #feefe9;

  color: #f56229;
}
.popupclose {
  position: fixed;
  text-align: center;
  bottom: 20px;
  width: 100%;
}
.searchValue {
  margin-bottom: 10px;
}
.searchValue:last-child {
  margin-bottom: 0;
}
</style>>



